<div class="container">
<div class="p-3 row">
    <div class="col">
        <div class="card">
            <div class="card-body">
                <h2 class="card-title">Support Info</h2>
                <p>Please contact us using the information below.</p>
                <p class="card-text">6-1111 Franklin Ave, Cambridge, Ontario Canada</p>
                <p>Phone: 1.416.877.2339</p>
                <p>Email: support@exactblue.com</p>
            </div>
            </div>
    </div>
</div>
</div>
